document.addEventListener('submit', function (e) {
  const form = e.target.closest('form[data-type="add-to-cart-form"]');
  if (!form) return;

  const addonCheckbox = document.querySelector('[data-addon-variant-id]');
  if (!addonCheckbox || !addonCheckbox.checked) return;

  e.preventDefault();

  const formData = new FormData(form);
  const items = [
    {
      id: formData.get('id'),
      quantity: parseInt(formData.get('quantity')) || 1,
    },
    {
      id: addonCheckbox.dataset.addonVariantId,
      quantity: 1,
    },
  ];

  fetch(routes.cart_add_url, {
    ...fetchConfig(),
    body: JSON.stringify({ items, sections: ['cart-drawer'], sections_url: window.location.pathname }),
  })
    .then((response) => response.json())
    .then((state) => {
      document.querySelector('cart-drawer').renderContents(state);
    })
    .catch(console.error);
}, true);